import { useState } from "react";
import { Play } from "lucide-react";
import { API } from "@/lib/api";

const ASPECT = {
  vertical: "aspect-[9/16] max-w-[340px]",
  horizontal: "aspect-video max-w-3xl",
  square: "aspect-square max-w-md",
};

function absUrl(u) {
  if (!u) return u;
  if (u.startsWith("/api/")) return `${API}${u.slice(4)}`;
  return u;
}

function VideoCard({ v }) {
  const [playing, setPlaying] = useState(false);
  const aspect = ASPECT[v.orientation] || ASPECT.vertical;
  const src = absUrl(v.url);

  if (v.autoplay) {
    return (
      <div className={`mx-auto w-full ${aspect} bg-black border border-white/10 overflow-hidden`} data-testid={`site-video-${v.id}`}>
        <video src={src} className="w-full h-full object-contain" autoPlay muted loop playsInline controls />
      </div>
    );
  }

  return (
    <div className={`relative mx-auto w-full ${aspect} bg-black border border-white/10 overflow-hidden group`} data-testid={`site-video-${v.id}`}>
      {playing ? (
        <video src={src} className="w-full h-full object-contain" autoPlay controls playsInline />
      ) : (
        <button onClick={() => setPlaying(true)} data-testid={`site-video-play-${v.id}`} className="absolute inset-0 w-full h-full">
          <video src={`${src}#t=0.1`} className="w-full h-full object-contain opacity-70" muted playsInline preload="none" />
          <span className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/15 transition-colors">
            <span className="w-16 h-16 rounded-full bg-nv/90 flex items-center justify-center glow-nv">
              <Play className="w-7 h-7 text-black ml-1" fill="currentColor" />
            </span>
          </span>
        </button>
      )}
    </div>
  );
}

export default function SiteVideos({ zone, videos }) {
  const list = (videos || []).filter((v) => (v.zone || "reviews2") === zone && v.url);
  if (list.length === 0) return null;
  return (
    <section className="bg-[#060505] border-b border-white/10 py-12" data-testid={`site-videos-${zone}`}>
      <div className="max-w-5xl mx-auto px-5 space-y-10">
        {list.map((v) => (
          <div key={v.id}>
            {v.title ? <h3 className="font-head text-lg text-neutral-200 mb-4 text-center tracking-wide">{v.title}</h3> : null}
            <VideoCard v={v} />
          </div>
        ))}
      </div>
    </section>
  );
}
